import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from './_services/auth.service';
import { FirestoreStoreService } from './_services/firestore-store.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'mevolve-connect';

  private auth = inject(AuthService);
  private store = inject(FirestoreStoreService);
  private authSubscription?: Subscription;

  ngOnInit(): void {
    // Subscribe to auth state changes to initialize/destroy store
    this.authSubscription = this.auth.authState$.subscribe(async (user) => {
      if (user) {
        // User logged in - initialize Firestore store
        console.log('[AppComponent] User authenticated, initializing Firestore store...');
        try {
          await this.store.initialize();
          console.log('[AppComponent] Firestore store initialized successfully');
        } catch (error) {
          console.error('[AppComponent] Failed to initialize Firestore store:', error);
        }
      } else {
        // User logged out - destroy Firestore store
        console.log('[AppComponent] User logged out, destroying Firestore store...');
        this.store.destroy();
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription
    this.authSubscription?.unsubscribe();
    this.store.destroy();
  }
}
